var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwiterFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29_8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.780493 0.195312L6.38248 7.7019L0.745117 13.8051H2.01386L6.94936 8.46165L10.9371 13.8051H15.2547L9.33751 5.87625L14.5847 0.195312H13.316L8.77063 5.1165L5.09808 0.195312H0.780493ZM2.64627 1.13189H4.62978L13.3886 12.8683H11.4051L2.64627 1.13189Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29_8"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwiterFooter);
export default __webpack_public_path__ + "static/media/twiter-footer.e831875cb4a7a2b014772cf6205a811f.svg";
export { ForwardRef as ReactComponent };